import React, {FC} from 'react';
import CautionTape from 'assets/images/cautiontape.png';
import CautionTapeWebp from 'assets/images/cautiontape.webp';
import {DefaultLayout} from 'components';
import {ROUTES} from 'constants/routes';
import {LazyImage} from 'hooks';
//@ts-ignore
import lqip from 'lqip.macro';
import {Helmet} from 'react-helmet-async';
import {Link} from 'react-router-dom';

const cautionLqip = lqip('../assets/images/cautiontape.png');
const layoutStyles = {
  lgColumns: 'lg:grid-cols-10',
  bgColor: 'bg-white',
};

const NoMatchPage: FC = () => {
  return (
    <DefaultLayout {...layoutStyles}>
      <Helmet>
        <title>Page Not Found | Wellnite Health</title>
      </Helmet>
      <section className="col-span-10 overflow-y-auto">
        <section className="flex flex-col h-screen items-center justify-center">
          <section className="w-full">
            <LazyImage
              lqip={cautionLqip}
              src={CautionTape}
              alt="Caution Tape"
              srcSet={`${CautionTape}`}
              type="image/png"
              webp={`${CautionTapeWebp}`}
              className="md:max-w-sm mx-auto w-1/2 md:w-auto object-contain"
              aspectRatio={1 / 1}
            />
          </section>
          <section className="text-center w-3/5">
            <h1 className="text-xl md:text-3xl font-light md:font-normal my-0 leading-snug text-gray-700 pb-12">
              Something went wrong. This page does not exist.
            </h1>
            <Link to={ROUTES.HOME}>
              <span className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded">
                Go Back to Home
              </span>
            </Link>
          </section>
        </section>
      </section>
    </DefaultLayout>
  );
};

export default NoMatchPage;
